<template>
    <EndpageTemplate :model="model" :recommended-events="recommendedEvents" />
</template>

<script>
import EndpageTemplate from '@/components/Pages/Event/Template';

export default {
    name: 'Program',
    components: {
        EndpageTemplate,
    },
    async asyncData({ $axios, params, redirect, localePath, i18n, store }) {
        let model = null;
        let recommendedEvents = [];

        await $axios
            .$get(`/events/by-slug/${params.program}`)
            .then((res) => {
                model = res;
                recommendedEvents = store.state.data.recommendedEvents.filter((x) => x.id !== model.id).slice(0, 5);
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('programs-in-varosliget'));
        }

        i18n.generateLocalizedRouteParams(model.locale_variants, 'program');

        return {
            model,
            recommendedEvents,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
